'use client'

import { useMemo, useState } from 'react'
import { formatCurrency, formatNumber } from '@/utils/Formatters'
import styles from './ua.module.scss'
import { buildCreditTiersDD, buildTermsDD, calcFinancePayment, calcFinancePrice, getDefaultSearchAPR } from '@/utils/DR'
import Field from '../form/Field'
import Form from '../form/Form'
import KeyValue from '../value/KeyValue'
import Button from '../button/Button'
import { genInvUrl, getFiltersFromParams } from '@/data/Inventory'
import { strings } from '@/utils/I18n'
import ApiUtils from '@/utils/ApiUtils'
import debounce from 'lodash.debounce'
import TradeSlider from './TradeSlider'
import { DM_EVENT_TRADE_ESTIMATE, useDMEventListener } from '@dealermesh/react'
import useEventListener from '../plugins/EventListener'
import CustomKeyValue from '../value/CustomKeyValue'
import { useRouter } from "next/navigation"


export default function BudgetFilter(props) {

  const site = props.site
  const creditTiers = buildCreditTiersDD(site.dr.credit_tiers)
  const terms = buildTermsDD(site.dr.finance.terms)
  
  const budget = props.budget || props.site.budget
  const [params,setParams] = useState(budget)
  const [creditTier,setCreditTier] = useState(site.session.credit_tier)
  const [enabled,setEnabled] = useState(props.enabled || false)
  const [priceFilterOn,setPriceFilterOn] = useState(false)
  const router = useRouter()

  
  useDMEventListener(DM_EVENT_TRADE_ESTIMATE, event => {
    if (event.detail?.value) {
      setFieldValue("tradeInValue", event.detail?.value)
    }
  })

  useEventListener("trade_removed", event => {
    setFieldValue("tradeInValue", 0)
  })
  
  const setFieldValue = (field, value) => {
    let data = Object.assign({}, params)
    if (field) data[field] = parseInt(value)
    let ct = creditTier
    if (field == 'creditTier') {
      ct = site.dr.credit_tiers.filter(e => parseInt(e.tier) == parseInt(value))[0]
      setCreditTier(ct)
    }
    if (field != 'price') {
      data['price'] = getBudgetPrice(data, ct)
      if (!props.toggle || enabled) {
        applyFilters(data, ct)
      }
    }
    if (field == 'price') {
      data['monthlyPayment'] = calcFinancePayment(parseInt(value), budget.apr, params.term, params.cashDown, params.tradeInValue, params.tradeInPayoff || 0)
      if (!props.toggle || enabled) {
        applyFilters(data, ct)
      }
    }
    setParams(data)
  }
  
  const getBudgetPrice = (params, tier) => {
    return parseInt(calcFinancePrice(params.monthlyPayment, getDefaultSearchAPR(tier), params.term, params.cashDown, params.tradeInValue, params.tradeInPayoff || 0))
  }
  
  const onApplyFilter = (params, tier) => {
    const price = getBudgetPrice(params, tier)
    let filterParams = { max_price: price, budget: params }
    if (!props.noApply) {
      props.listingRef.current.applyFilters(filterParams)
    }
    track(params)
  }
  
  const applyFilters = useMemo(() => debounce(onApplyFilter, 500), [])
  
  const trackBudget = (budgetParams) => {
    ApiUtils.logEvent({
      dr: {
        monthlyPayment: budgetParams.monthlyPayment,
        tradeInValue: budgetParams.tradeInValue,
        tradeInPayoff: budgetParams.tradeInPayoff || params.tradeInPayoff || 0,
        cashDown: budgetParams.cashDown,
        term: budgetParams.term,
        creditTier: budgetParams.creditTier,
        apr: getDefaultSearchAPR(creditTier),
        price: budgetParams.price,
      }
    })
  }
  
  const track = useMemo(() => debounce(trackBudget, 100), [])
  
  const toggleBudgetFilering = (e) => {
    if (enabled) {
      setEnabled(false)
      props.listingRef.current.applyFilters({ max_price: null, budget: null, clear: true })
      props.listingRef.current.toggleBudgetFilter(e)
    } else {
      setEnabled(true)
      track(params)
      let urlParams = Object.assign(getFiltersFromParams(props), props.filters || {})
      urlParams.max_price = params.price
      const url = genInvUrl(urlParams, {})
      router.push(url)
      // props.listingRef.current.applyFilters({ max_price: params.price, budget: params})
    }
  }

  const togglePriceFilter = (on) => {
    setPriceFilterOn(on)
  }

  return (
    <div className={ styles.fltc + ' ' + (props.shadow ? styles.fltsdw : '')}>
      <Form id="home_top_filter" name="Home Page Filters" className={ styles.fltp }>
        <div className={styles.pmt}>
          <div className={ styles.pmtP }>
            <div className={ styles.pmtPD3 }>
              <CustomKeyValue>
                <label style={{paddingLeft: '4px'}}>
                  <div className='flex-row'>
                    <div className='flex-col'>
                      <div className={ styles.stoggle}>
                        <div>
                          <a className={'flex-col ' + (!priceFilterOn ? styles.stoggle_active : '')} onClick={e => togglePriceFilter(false)}>{ strings(props.site)['dr_monthlyPayment'] }</a>
                          <a className={'flex-col ' + (priceFilterOn ? styles.stoggle_active : '')} onClick={e => togglePriceFilter(true)}>{ 'Price' }</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </label>
                <span>{priceFilterOn ? formatCurrency(params.price) : formatCurrency(params.monthlyPayment)}</span>
              </CustomKeyValue>
              { priceFilterOn ?
              <Field key={'priceFilterOn1'} name="price" type="slider" min="0" max={200000} value={params.price} step={100} onChange={value => setFieldValue('price', value)}></Field>
              :
              <Field key={'priceFilterOn0'} name="monthlyPayment" type="slider" min="0" max={site.dr.max_payment || 1} value={budget.monthlyPayment} step={10} onChange={value => setFieldValue('monthlyPayment', value)}></Field>
              }
            </div>
            <div className={ styles.pmtPD3 }>
              <TradeSlider {...props} tradeInValue={budget.tradeInValue} trade={props.site.session?.vehicles?.trade} onChange={value => setFieldValue('tradeInValue', value)}></TradeSlider>
            </div>
            {/* <div className={ styles.pmtPD3 }>
              <KeyValue label={ strings(props.site)['dr_tradeInValue'] } value={formatCurrency(params.tradeInValue)}>
                <div><Button theme={['white']}>Get Estimate</Button></div>
              </KeyValue>
              <Field name="tradeInValue" type="slider" min="0" max="25000" value={budget.tradeInValue || 1} step={50} onChange={value => setFieldValue('tradeInValue', value)}></Field>
            </div> */}
            <div className={ styles.pmtPD3 }>
              <KeyValue label={ strings(props.site)['dr_cashDown'] } value={formatCurrency(params.cashDown)}></KeyValue>
              <Field name="cashDown" type="slider" min="0" max={site.dr.max_cash_down} value={budget.cashDown || 1} step={100} onChange={value => setFieldValue('cashDown', value)}></Field>
            </div>
          </div>
          <div className={ styles.pmtP2 }>
            <div className={ styles.pmtP2D2 }>
              <Field inline={true} name="term" label={strings(props.site)['dr_loanTerms']} type="select" options={terms} value={params.term} onChange={value => setFieldValue('term', value)}></Field>
            </div>
            <div className={ styles.pmtP2D2 }>
              <Field inline={true} name="creditTier" label={strings(props.site)['dr_creditRange']} type="select" value={params.creditTier} options={creditTiers} onChange={value => setFieldValue('creditTier', value)}></Field>
            </div>
          </div>
        </div>
        <div className={ styles.sum }>
          <div className={ styles.sumL }>{ priceFilterOn ? 'Approx. Budget' : 'Approx. Monthly' }</div>
          <div className={ styles.sumP }>
            <span>$</span>
            <span>{ priceFilterOn ? formatNumber(params.price) : formatNumber(params.monthlyPayment) }</span>
          </div>
          <div className={ styles.sumB }>
            { props.toggle ?
            <div><Button theme={ enabled ? "line-secondary" : "secondary" } label={ enabled ? "Clear Budget" : "Set Budget" } style={{width:'200px'}} onClick={e => toggleBudgetFilering(e)}></Button></div>
            :
            <div><Button theme="secondary" label="Shop Cars in Budget" href={genInvUrl(Object.assign({}, props.filters, {max_price: params.price}), {}, false)}></Button></div>
            }
          </div>
        </div>
      </Form>
    </div>
  )
  
}